module.exports = __webpack_public_path__ + "img/DSC_2688-xs.d487ccc0.png";